<template>
  <div class="">
    <div class="m-field-group grid-x grid-padding-x small-up-2">
      <div class="cell m-field-group">
        <button
          class="a-button a-button--full-width a-button--main gtm-HPFromTransferDirection"
          type="submit"
          @click="homePageToCourseToCourse('from')"
        >
          From
        </button>
      </div>
      <div class="cell m-field-group">
        <button
          class="a-button a-button--full-width a-button--main gtm-HPToTransferDirection"
          type="button"
          @click="homePageToCourseToCourse('to')"
        >
          To
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  nonce: {
    required: true,
  },
  filtersPagePath: {
    default: false,
  },
})

function homePageToCourseToCourse(fromTo) {
  let searchParams = new URLSearchParams()
  searchParams.set('fromTo', fromTo)

  window.location.href = props.filtersPagePath + '?' + searchParams.toString()
}
</script>
